import { useQuery } from '@tanstack/react-query';
import api from 'services/api';

const useReportConfigs = ({ experimentId }) => {
  const fetchReportConfigs = async (experimentId) => {
    try {
      const response = await api.get(`/api/v1/trials/experiments/${experimentId}/report-configs`);
      const data = await response.json();
      return data.data;
    } catch (error) {
      return Promise.reject(error);
    }
  };

  return useQuery(['report-configs', experimentId], () => fetchReportConfigs(experimentId), {
    enabled: !!experimentId, // Only runs if experimentId exists
    refetchOnWindowFocus: false,
  });
};

export default useReportConfigs;

